import { Select } from "@portal/BaseComponents/Select/AntSelect";
import { PTPStatus } from "@portal/types/entities/ptp";
import { styled } from "@stitches/react";

export const StyledPTPStatus = styled(Select<Exclude<PTPStatus, "ALL">>, {
  ".ant-select-selection-item": {
    color: "var(--statusTextColor)",
  },
  "&.ant-select:not(.ant-select-customize-input) .ant-select-selector": {
    border: " 1px solid var(--statusBorderColor) !important",
  },

  ".ant-select-arrow": {
    color: " var(--gray-9)",
  },
});
